<script setup lang="ts">
import _ from "lodash";

const authStore = useAuthStore();
const walletStore = useWalletStore();
walletStore.reconcileWallets();

const route = useRoute();
const notice = computed(() =>
  route.path === "/disperse"
    ? {
        message: "Disperse has issues. Tickets won't help, I can't fix it now.",
        href: "/faq#what-if-disperse-doesnt-work",
        linkText: "What to try",
        variant: "error" as const,
      }
    : {
        message: "Mint didn't work? Found a bug? Please report it.",
        href: "https://discord.com/channels/1281586674576654351/1333339771870904423",
        linkText: "Report an issue",
        variant: "default" as const,
      }
);
</script>

<template>

  <section
    v-if="authStore.user"
    class="relative flex sm:flex-row flex-col sm:justify-center items-start w-full h-screen sm:h-auto sm:pt-48 min-h-screen sm:space-x-10 sm:px-4">

    <GenericBugNotice
      class="sm:hidden animate-fade-in opacity-0 [animation-delay:100ms]"
      :message="notice.message"
      :href="notice.href"
      :link-text="notice.linkText"
      :variant="notice.variant" />

    <div class="w-full flex justify-between sm:hidden px-4 py-1 z-50 border-b dark:border-gray-700 bg-gray-50 dark:bg-gray-800">
      <div class="flex items-center">
        <div class="flex flex-col">
          <span class="text-xs font-semibold">{{ _.capitalize(authStore.user.discordUsername) }}</span>
          <GenericAddress :value="authStore.user.accountAddress" />
        </div>

        <UButton
          class="ml-4 px-5"
          color="white"
          icon="i-tabler-logout"
          @click="authStore.logout()" />
      </div>
      <div class="flex items-center space-x-6">
        <ThemeToggle />
        <GenericFiatToggle />
      </div>
    </div>

    <SideNavigation class="sticky sm:top-48 hidden mb-auto w-48" />
    <div
      ref="sliver"
      class="max-w-xl w-full js-sliver overflow-x-auto sm:overflow-x-visible h-full">
      <GenericBugNotice
        class="hidden sm:flex mb-4 animate-fade-in opacity-0 [animation-delay:200ms]"
        :message="notice.message"
        :href="notice.href"
        :link-text="notice.linkText"
        :variant="notice.variant" />
      <slot />
    </div>

    <div class="w-full flex flex-col justify-end sm:hidden bg-gray-50 dark:bg-gray-800 z-50 border-t border-gray-300 dark:border-gray-600">
      <BottomNavigation />
    </div>

    <GenericModalMismatchedAddress />
    <GenericGasCalculatorModal />
  </section>

</template>
